import { useEffect, useMemo, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  directionAPI,
  directionGroupApi,
  directionOrdersApi,
  homeWorkApi,
  usersAPI,
  beta,
} from "@api";
import { createDate } from "@helpers/date";
import { useCalendar } from "@hooks";
import { actionGetOwnBacklog } from "@store/children/children.reducer";
import {
  getMyTimetableState,
  setMyClassesState,
  setMyDirectionState,
  setMyGroupsState,
} from "@store/common/common.reducer";
import { setUnverifiedHM } from "@store/seminarian/seminarian.reducer";
import { selectProfile, actionUpdProfile } from "@store/profile.reducer";
import { AuthService } from "@/services/AuthService";
import { useHistory } from "react-router-dom";
import { selectIsAuth } from "@store/profile.reducer";
import { SETTINGS_TYPES } from "@/constant";
import { fetchAllRoles } from "@store/allRolesSlise";
import { useGetId } from "@/hooks/useGetId";
import { fetchParentSelectedChild } from "@store/parent/parentSelectedChildSlice";
import { fetchTimetableData } from "@store/timetable/fetchTimetableData";
import useDefaultAuthRedirect from "@/routes/components/useDefaultAuthRedirect";
import { filterAddMeeInSeminarians, resetState, setType } from "@store/timetable/timetableSlice";
import { checkSettingsStore } from "@/services/SettingsStoreUpdateService";
import { useAddAlert } from "@/hooks/useAddAlert";
import { typesEnum } from "@pages/Main/Timetable/components/Types/typesEnum";
import { changeLanguages } from "@store/languages-reduser";
import initstateAddUniqueDZ from "@modals/Homework/CreateUniqueHomework/initState";
import { useLocalStorage } from '@/hooks/useLocalStorage'
import { addOneMinute, fetchPlatformTime } from "@store/platformTime/platformTimeSlice";
import { fetchBalanceOfAdditionalActivities } from "@store/balanceOfAdditionalActivitiesSlise";
import TYPES from "@modals/TYPES";
import { openModal } from "@store/modalsSlise";
import { periodModes } from "@pages/Main/Timetable/components/PeriodMode/periodModes";
import {
  finishGoogleTranslationLoading,
  prepareInitialGoogleTranslation,
} from "@common/Header/components/CustomGoogleTranslate/googleTranslateService";

const Technical = () => {
  const [stateAddUniqueDZ, setStateAddUniqueDZ, removeStateAddUniqueDZ] = useLocalStorage(
      'addUniqueDZ',
      initstateAddUniqueDZ,
  )
  useDefaultAuthRedirect();

  const addAlert = useAddAlert();
  useEffect(() => {
      checkSettingsStore()
          .catch((error) => {
              addAlert({
                  title: `УПС! Возникла ошибка... Настройки платформы не загружены...`,
                  text: error?.message,
                  type: 'error'
              });
          });
  }, []);

  const childrenId = useGetId();
  var d = useDispatch();
  var profile = useSelector(selectProfile);
  const status = useSelector(store => store.settings?.status);
  const loadingSettings = status < 2;
  const isRegistrationAndPaymentForCourseViaSchedule = useSelector(store => store.settings?.isRegistrationAndPaymentForCourseViaSchedule);
  const isAllDefaultSchedule = useSelector(store => store.settings?.isAllDefaultSchedule);
  const isDefaultDisplayTimetableByDays = useSelector(store => store.settings?.isDefaultDisplayTimetableByDays);
  const defaultStudentTimetablePeriodMode = useSelector(store => store.settings?.defaultStudentTimetablePeriodMode);
  const defaultEmployeeTimetablePeriodMode = useSelector(store => store.settings?.defaultEmployeeTimetablePeriodMode);
  const isSeniorSeminarianManageCoursesClasses = useSelector(store => store.settings?.isSeniorSeminarianManageCoursesClasses);
  const automaticallyAddToFilterInSchedule = useSelector(store => store.settings?.automaticallyAddToFilterInSchedule);
  const hideManualsModalAutoOpen = useSelector(store => store.settings?.hideManualsModalAutoOpen);

  const loadingSettingsRef = useRef(loadingSettings);
  const isSeniorSeminarianManageCoursesClassesRef = useRef(isSeniorSeminarianManageCoursesClasses);

  useEffect(() => {
    loadingSettingsRef.current = loadingSettings;
    isSeniorSeminarianManageCoursesClassesRef.current = isSeniorSeminarianManageCoursesClasses;
  }, [loadingSettings, isSeniorSeminarianManageCoursesClasses]);

  var newDate = useMemo(() => new Date(), []);
  var { state: month } = useCalendar({
    selectedDate: newDate,
    firstWeekDay: 2,
  });

  var isAuth = useSelector(selectIsAuth);
  var locationIsLogin =
    window.location.pathname === "/auth" ||
    window.location.pathname === "/register" ||
    window.location.pathname === "/restore-password" ||
    window.location.pathname === "/signup-vk" ||
    window.location.pathname === "/auth/app/" ||
    window.location.pathname === "/auth" ||
    window.location.pathname.match(/news\/[0-9]/) ||
    window.location.pathname.includes('/courses/all') ||
    window.location.pathname.match(/my-survey-link\/[0-9]/) ||
    window.location.pathname === '/payment-without-registration' ||
    window.location.pathname === '/purchasing-course-or-class-using-link' ||
    window.location.pathname === "/calculator" ||
    window.location.pathname === "/profile-view" ||
    window.location.pathname === "/home-work/work-link" ||
    // Проверка на payment-form с JWT в data
    (window.location.pathname === '/payment-form' && 
     /[?&]data=[A-Za-z0-9\-_]+\.[A-Za-z0-9\-_]+\.[A-Za-z0-9\-_]+/.test(window.location.search))
      ? true
      : false ||
    (window.location.pathname === '/authorization-via-link-by-params')

  const technical = async () => {
    var date = createDate();
    // Все кроме УЧЕНИКОВ
    let groupsSupervisor = []
    if (profile.role ) {
      const res = await usersAPI.getUser({ id: profile.id, expand: ["roles", "userProfile", "workHours", "groups_supervisor"] });
      if (res?.data) {
        const data = { ...res.data };
        groupsSupervisor = data?.groups_supervisor ?? [];
        if (res?.data?.roles.length > 0)
          data.roles = res?.data?.roles?.map((i) => i?.item_name);
        d(actionUpdProfile(data));
      }

      d(fetchAllRoles());
    }

    if(profile.role === 'children' || profile.role === 'parent'){
        if(!childrenId) return;
       
        if(profile.role === 'children'){
          d(getMyTimetableState({ year: date.year, month: date.monthNumber }, month));
        }
        
        // Получаем направления ребенка
        const res = await directionOrdersApi.get({
          filter: [`[children_id][eq]=${childrenId}`, `[is_disabled][eq]=0`],
          expand: ["direction.directionTariffs", "group", "class", 'direction.mediaIcon'],
          pageSize: false,
        });
        d(
          setMyDirectionState(
            res?.data?.data.map(({ direction, ...order }) => ({
              ...direction,
              order,
            }))
          )
        );

        const classesIds = []
        
        d(
          setMyClassesState(
            res?.data?.data.filter((item) => { 
                if(item?.class?.id && !classesIds.includes(item?.class?.id)){
                  classesIds.push(item?.class?.id)
                  return true
                }
                return false
            }).map(( el ) => el?.class)
          )
        );

        const groupsMy = res.data.data
          .map((item) => item.group)
          ?.filter((item) => item?.id !== undefined);
        d(setMyGroupsState(groupsMy));

        // Получаем не выполненное дз, пробники, кр и соп
        d(actionGetOwnBacklog());

        if (childrenId && profile.role === 'parent') {
          d(fetchParentSelectedChild(childrenId));
        }
    }
    switch (profile?.role) {
      case "senior-seminarian": {
        const coursesForSeniorSeminarian = await beta.getCoursesForSeniorSeminarian()
        d(actionUpdProfile({ directionIds: coursesForSeniorSeminarian?.data ?? [] }));
        {
          const res = await directionAPI.getAll({
            filter: [`[direction_id][in][]=${coursesForSeniorSeminarian?.data ?? []}`],
            expand: ['directionTariffs']
          });
          d(setMyDirectionState(res?.data?.data));
        }

        {
          while (loadingSettingsRef.current) {
            await new Promise(resolve => setTimeout(resolve, 100));
          }
          if(isSeniorSeminarianManageCoursesClassesRef.current == '1' && !coursesForSeniorSeminarian?.data?.length){
            d(setMyGroupsState([]));
          }
          else{
            // получение своих групп
            const res = await directionGroupApi.get({
              filter: coursesForSeniorSeminarian?.data?.map(
                (item) => `[direction_id][in][]=${item}`
              ),
              expand: ["direction"],
            });         
          
            const groups = isSeniorSeminarianManageCoursesClassesRef.current == '1' 
                  ? res.data?.filter(group => groupsSupervisor.includes(String(group.id))) : res.data;
            d(setMyGroupsState(groups));
          }
        }

        break;
      }
      case "seminarian": {
        removeStateAddUniqueDZ()
        {
          d(getMyTimetableState({ year: date.year, month: date.monthNumber }, month));
          
          // получение своих групп
          const res = await directionGroupApi.get({
            filter: [`[teacher_id][eq]=${profile.id}`],
          });
          const data = { groupsIds: [] };
          if (res.data.length)
            res.data.forEach((item) => data.groupsIds.push(item.id));
          d(actionUpdProfile(data));
          d(setMyGroupsState(res.data));
        }

        {
          // получение направлений
          const res = await usersAPI.directionBySeminarian({
            id: profile?.id,
            params: { expand: "direction.directionTariffs,direction.mediaIcon" },
          });
          
          const directions = res?.data?.data?.map(({ direction }) => direction);
          d(
            actionUpdProfile({
              directionIds:
                profile?.directionIds ?? directions?.map(({ id }) => id),
              myDirection: directions,
            })
          );
          d(setMyDirectionState(directions));
        }

        {
          // получение не проверенных домашек
          const res = await homeWorkApi.getOwnWorksForRedax({
            filter: [`[status][eq]=5`],
            expand: ["direction", "children"],
            pageSize: false,
          });
          d(
            setUnverifiedHM({
              list: res.data?.data,
              count: res.data?._meta?.totalCount,
            })
          );
        }
        break;
      }
      default:
        break;
    }
  };

  const history = useHistory();

  const logout = async () => {
    await AuthService.logout();
    history.push("/auth");
  };

  useEffect(() => {
    if (isAuth) technical();
    else if (!locationIsLogin && !isAuth) logout();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [profile.role, childrenId]);

  const typeAllForTimtable = (profile.role === 'children' || profile.role === 'parent') 
                      && isRegistrationAndPaymentForCourseViaSchedule == '1' 
                      && isAllDefaultSchedule == '1';
  const defaultTimetablePeriodMode = useMemo(() => {
    const isStudentRole = profile.role === 'children' || profile.role === 'parent';
    const settingValue = isStudentRole
      ? defaultStudentTimetablePeriodMode
      : defaultEmployeeTimetablePeriodMode;

    if (Object.values(periodModes).includes(settingValue)) {
      return settingValue;
    }

    return isDefaultDisplayTimetableByDays === '1' ? periodModes.day : periodModes.week;
  }, [profile.role, defaultStudentTimetablePeriodMode, defaultEmployeeTimetablePeriodMode, isDefaultDisplayTimetableByDays]);

  useEffect(()=>{
    if(loadingSettings) return;
    if(!isAuth) return;
    if(
      profile.role === 'children' 
      || profile.role === 'parent' 
      || profile.role === 'admin'
      || profile.role === 'junior-admin'
      || profile.role === 'senior-seminarian'
      || profile.role === 'seminarian'
    ){
      d(resetState({
        role: profile.role,
        defaultPeriodMode: defaultTimetablePeriodMode,
        defaultSingleDayView: isDefaultDisplayTimetableByDays === '1'
      }));
      const addMe = (profile.role === 'admin' || profile.role === 'junior-admin' || profile.role === 'senior-seminarian') && automaticallyAddToFilterInSchedule == '1';

      d(fetchTimetableData({addMe, typeAll: typeAllForTimtable}));
      if(addMe){
       d(filterAddMeeInSeminarians(profile.id)) 
      }
      if(typeAllForTimtable){
        d(setType(typesEnum.all))
      }
      if((profile.role === 'children' || profile.role === 'parent') && isRegistrationAndPaymentForCourseViaSchedule === '1' && !!childrenId){
        d(fetchBalanceOfAdditionalActivities(childrenId));
      }
    }
  }, [profile.role, childrenId, typeAllForTimtable, loadingSettings, isDefaultDisplayTimetableByDays, defaultTimetablePeriodMode])

  useEffect(() => {
    if(isAuth) {
      // Первоначальная загрузка времени с сервера
      d(fetchPlatformTime());
      let lastPlatformTimeSyncAt = Date.now();
      const syncPlatformTime = () => {
        if (document.visibilityState === 'hidden') return;
        if ((Date.now() - lastPlatformTimeSyncAt) < 10000) return;
        lastPlatformTimeSyncAt = Date.now();
        d(fetchPlatformTime());
      };

      // Обновление времени с сервера каждую минуту
      const serverUpdateInterval = setInterval(() => {
        d(addOneMinute());
      }, 60000); // 60 секунд

      document.addEventListener('visibilitychange', syncPlatformTime);
      window.addEventListener('pageshow', syncPlatformTime);

      return () => {
        clearInterval(serverUpdateInterval);
        document.removeEventListener('visibilitychange', syncPlatformTime);
        window.removeEventListener('pageshow', syncPlatformTime);
      };
    }
  }, [isAuth]);

  useEffect(() => {
    const handleBeforeUnload = () => {
      // general и crm: иначе после правок админа у других юзеров остаётся старый localStorage
      localStorage.removeItem(SETTINGS_TYPES.GENERAL);
      localStorage.removeItem(SETTINGS_TYPES.CRM);
    };

    window.addEventListener('beforeunload', handleBeforeUnload);

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, []);
  useEffect(() => {
    if (
      isAuth &&
      profile.role === 'admin' &&
      !loadingSettings &&
      hideManualsModalAutoOpen !== '1'
    ) {
      const seen = localStorage.getItem('manualsModalSeen')
      if (!seen) {
        d(openModal({ type: TYPES.MANUALS_MODAL }))
      }
    }
  }, [isAuth, profile.role, loadingSettings, hideManualsModalAutoOpen])

  useEffect(() => {
    fetch(`${process.env.REACT_APP_URL_API}languages`)
      .then((response) => {
        if (!response.ok) throw new Error("Failed to load languages")
        return response.json()
      })
      .then((data) => {
        prepareInitialGoogleTranslation(data)
        d(changeLanguages(data))
      })
      .catch(finishGoogleTranslationLoading)
  }, [])

  return null;
};

export default Technical;
